import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

type BackfillIssueCountsParams = {
  shouldOverwriteExisting: boolean;
};

async function backfillIssueCounts({ shouldOverwriteExisting }: BackfillIssueCountsParams): Promise<void> {
  await post('/api/issue_counts/backfill', { shouldOverwriteExisting });
}

/**
 * Hook to backfill issue count snapshots for the current organization.
 * @returns Mutation function to trigger issue count snapshot backfill
 */
export const useBackfillIssueCounts = () => {
  return useToastedMutation({
    mutationFn: backfillIssueCounts,
    successToastMessage: 'Issue count snapshot backfill queued successfully',
    errorToastMessage: 'Failed to queue issue count snapshot backfill',
  });
};
